import type { Monaco } from "@monaco-editor/react";
import { shikiToMonaco } from "@shikijs/monaco";
import { createHighlighter, type Highlighter } from "shiki";

const THEMES = [
  "github-light-default",
  "github-dark-default",
  "light-plus",
  "dark-plus",
] as const;

export type EditorTheme = (typeof THEMES)[number];

/** The host's pick for each OS color scheme. */
export interface EditorThemes {
  light: EditorTheme;
  dark: EditorTheme;
}

let highlighter: Promise<Highlighter> | undefined;

/** One highlighter for every editor. Monaco keys `.ts`/`.tsx` (and `.js`/`.jsx`)
 *  to one language id each, so those ids get the JSX-aware grammars. */
export function loadHighlighter(): Promise<Highlighter> {
  highlighter ??= createHighlighter({
    themes: [...THEMES],
    langs: ["tsx", "jsx", "json", "markdown", "css", "html", "yaml", "python"],
    langAlias: { typescript: "tsx", javascript: "jsx" },
  });
  return highlighter;
}

const installed = new WeakSet<Monaco>();

/** Swap Monaco's tokenizers and themes for Shiki's, once per Monaco instance. */
export function installShiki(monaco: Monaco, loaded: Highlighter): void {
  if (installed.has(monaco)) return;
  installed.add(monaco);
  shikiToMonaco(loaded, monaco);
}
